export default __webpack_public_path__ + "static/media/canshugaijin.46a9eb2a.svg";